import React, { useCallback } from 'react';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import without from 'lodash/without';

import { ProductsIndexTableRowBrandNameFilterButtonProduct } from './ProductsIndexTableRowBrandNameFilterButton.types';
import {
  ChangeProductsFiltersFunc,
  FetchProductsFilters
} from '../../../../../productsTypes';

import { PureTooltipIconButtonHelper } from '../../../../../../../helpers/buttons/PureTooltipIconButtonHelper';
import { TooltipPlacement } from '../../../../../../../helpers/tooltips/tooltipsConstants';
import { GADataType } from '../../../../../../../types';

interface ProductsIndexTableRowBrandNameFilterButtonProps {
  product: ProductsIndexTableRowBrandNameFilterButtonProduct;
  productsFilters?: FetchProductsFilters;
  changeProductsFilters?: ChangeProductsFiltersFunc;
}

function ProductsIndexTableRowBrandNameFilterButton({
  dataGa,
  product,
  changeProductsFilters,
  productsFilters
}: ProductsIndexTableRowBrandNameFilterButtonProps & GADataType) {
  const brandId = product.brand?.id;

  const handleClick = useCallback<() => void>(() => {
    const currentBrandFilterIds = productsFilters?.brandId?.in || [];

    if (includes(currentBrandFilterIds, brandId)) {
      const currentBrandFilterIdsWithoutProductBrand = without(
        currentBrandFilterIds,
        brandId
      );
      changeProductsFilters?.(
        {
          brandId: { in: currentBrandFilterIdsWithoutProductBrand }
        },
        isEmpty(currentBrandFilterIdsWithoutProductBrand) ? ['brandId'] : null
      );
    } else {
      changeProductsFilters?.({
        brandId: { in: [...currentBrandFilterIds, brandId] }
      });
    }
  }, [brandId, productsFilters, changeProductsFilters]);

  if (!product.brand?.localizedName) {
    return null;
  }
  return changeProductsFilters ? (
    <PureTooltipIconButtonHelper
      dataGa={dataGa}
      className="focus:ring-offset-0 focus:ring-0 hover:opacity-80"
      text={product.brand.localizedName}
      tooltipText={product.brand.localizedName}
      tooltipPlacement={TooltipPlacement.BOTTOM}
      icon={null}
      onClick={handleClick}
    />
  ) : (
    <span>{product.brand.localizedName}</span>
  );
}

export default ProductsIndexTableRowBrandNameFilterButton;
